import { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { Loader } from 'lucide-react';

const Auth0CallbackPage = () => {
    const { isAuthenticated, isLoading, getAccessTokenSilently, user: auth0User, error: auth0Error } = useAuth0();
    const { handleGoogleAuth } = useAuthStore();
    const navigate = useNavigate();
    const hasFired = useRef(false);  // prevents double-fire in StrictMode

    useEffect(() => {
        if (isLoading || hasFired.current) return;

        // Auth0 itself had an error (e.g. user closed popup)
        if (auth0Error) {
            navigate('/login?error=google_auth_failed');
            return;
        }

        if (!isAuthenticated || !auth0User) return;

        const sendToBackend = async () => {
            hasFired.current = true;
            try {
                const accessToken = await getAccessTokenSilently();
                const result = await handleGoogleAuth(accessToken);

                if (result.needsProfileCompletion) {
                    navigate('/complete-profile');
                } else {
                    navigate('/');
                }
            } catch (err) {
                const msg = err?.response?.data?.message || 'google_auth_failed';
                navigate(`/login?error=${encodeURIComponent(msg)}`);
            }
        };

        sendToBackend();
    }, [isAuthenticated, isLoading, auth0User, auth0Error]);

    return (
        <div className="flex justify-center items-center min-h-screen">
            <div className="flex flex-col items-center gap-4">
                <Loader className="animate-spin size-10 text-purple-500" />
                <p className="font-libre text-gray-400 text-sm">Signing you in...</p>
            </div>
        </div>
    );
};

export default Auth0CallbackPage;